import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../hotel.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../../../../environments/environment'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HotelPaymentConfirmationComponent } from '../hotel-payment-confirmation/hotel-payment-confirmation.component'
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

const b2b_url = `${environment.b2b_url}/b2b`

export interface DialogData {
    appReference,
    paymentType,
    merchantInvoiceNumber: "Inv002"
}

let $: any
@Component({
    selector: 'app-hotel-payment-detail',
    templateUrl: './hotel-payment-detail.component.html',
    styleUrls: ['./hotel-payment-detail.component.scss']
})
export class HotelPaymentDetailComponent implements OnInit, OnDestroy {

    private subSink = new SubSink();
    roomCount: any;
    room: any;
    paxDetails: any;
    hotel: any;
    pax: any;
    nights: any;
    totalFare: any = 0;
    data: any;
    adultCount: any = 0;
    childCount: any = 0;
    currentUser: any;
    paymentForm: FormGroup;
    submitted: boolean
    appReference: string = ""
    srcUrl: string = ""
    showPaymentModal: boolean = false;
    booking_source: string = '';
    showPaymentDetails: boolean;
    paymentGateways: any;
    loading: boolean;
    loadingTemplate: any;
    primaryColour: any;
    secondaryColour: any;
    paymentData: any;
    confirmDetails: any;
    refundable: any;
    discountAmount: any;
    Convenience: any;
    constructor(
        private hotelService: HotelService,
        private util: UtilityService,
        private apiHandlerService: ApiHandlerService,
        private router: Router,
        private swalService: SwalService,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private ngxService: NgxUiLoaderService,
        private cdr: ChangeDetectorRef,
    ) { }

    ngOnInit() {

        this.route.queryParams.subscribe(params => {
            this.booking_source = params['bookingSource'];
            this.appReference = params.appReference;
        })
        this.setpaxDetails();
        this.setConfirmDetails();
        this.createPaymentForm();
        this.hotelVoucher();
    }

    setpaxDetails() {
        const storedState = localStorage.getItem('hotelCommitBookingResponse');
        if (storedState) {
          this.hotelService.addHotelBookingPaxDetails.next(JSON.parse(storedState));
        }
      }

      setConfirmDetails() {
        this.hotelService.addHotelBookingPaxDetails.subscribe(res => {
          this.confirmDetails = res;
          console.log("res",res)
          let bookingData = this.confirmDetails.BookingDetails.Attributes.replace(/'/g, '"');
          this.discountAmount = this.confirmDetails.BookingItineraryDetails[0].discountAmount;
          this.refundable = JSON.parse(bookingData).Refundable;
        });
      }

    hotelVoucher(){
        this.loading=true;
    this.subSink.sink = this.apiHandlerService.apiHandler('hotelVoucher', 'post', {}, {}, {
        AppReference: this.appReference,
        booking_source: "ZBAPINO00008"
    }).subscribe(resp => {
        if (resp.statusCode == 201 || resp.statusCode == 200) {
            this.loading=false;
            this.room = resp.data.BookingItineraryDetails;
            this.hotel = resp.data.BookingDetails;
            this.cdr.detectChanges();
            this.paxDetails = resp.data.BookingPaxDetails;
            this.Convenience = Number(this.room[0].OtherCharges);
            this.pax = this.paxDetails.length;
            this.roomCount = this.room.length;

            this.room.forEach(element => {
                this.totalFare += element.RoomPrice;
            });
            this.paxDetails.forEach((element, i, arr) => {
                if (i != arr.length) {
                    if (element.PaxType == 'Adult') {
                        this.adultCount += 1;
                    } else if (element.PaxType == 'Child') {
                        this.childCount += 1;
                    }
                }
            });
            this.ngxService.stop();
            this.nights = this.util.noOfNights(this.hotel.HotelCheckIn, this.hotel.HotelCheckOut);
            this.cdr.detectChanges();
        }
    })
}

    createPaymentForm() {
        this.paymentForm = this.fb.group({
            paymentMethod: new FormControl('', [Validators.required])
        });
    }

    hasError = (controlName: string, errorName: string) => {
        return ((this.submitted || this.paymentForm.controls[controlName].touched) && this.paymentForm.controls[controlName].hasError(errorName));
    }

    onBooking(appReference) {
       
        this.submitted = true;
        if (!this.hotelService.isDevelopment) {
            if (!this.paymentForm.valid)
                return;
        }
        if (this.paymentForm.value.paymentMethod == "wallet") {
            //this.walletPayment(appReference);
            this.reservation()
        }
        if (this.paymentForm.value.paymentMethod == "nagad") {
            this.nagadPayment()
        }
        if (this.paymentForm.value.paymentMethod == "bKash") {
            window.location.href = `${b2b_url}/paymentGateway/${appReference}`
        }
    }
    walletPayment(appReference) {
        this.hotelService.loading.next(true);
        this.subSink.sink = this.apiHandlerService.apiHandler('checkWalletBalance', 'post', '', '', { app_reference: appReference })
            .subscribe(res => {
                if (res && res.data[0].ticketFare) {
                    if (res.data[0].ticketFare > res.data[0].userWalletBalance) {
                        this.hotelService.loading.next(false);
                        this.swalService.alert.oops("Your wallet balence is not sufficient.")
                    } else {
                        this.reservation();
                    }
                }
            }, (err) => {
                this.hotelService.loading.next(false);
                this.swalService.alert.oops("Your wallet balence is not sufficient.")
            });
    }

    
 
 intitiatePayment(){
   let date = (new Date().getTime()).toString();
   const userId = this.util.readStorage('b2cUser', sessionStorage)['id']
   const order_id = `IR${date.substring(10)}${date.substring(0, 7)}${date.substring(7)}`;
   let payload = {
       app_reference: this.appReference,
       order_id: order_id,
       payment_type: "Stripe",
       merchantInvoiceNumber: "Inv002",
       source: "hotel",
       userId: userId ? userId : 0,
   }
   localStorage.setItem('orderId',order_id);
   this.subSink.sink = this.apiHandlerService.apiHandler('transactionInit', 'post', '', '', payload).subscribe(res => {
       if (res) {
           this.paymentData = res.data;
           const redirectUrl = this.paymentData.url;
           window.location.href = redirectUrl;
       }
   });
 }

    reservation() {
        console.log("entersss")
        this.loading=true;
        this.subSink.sink = this.apiHandlerService.apiHandler('reservation', 'post', {}, {}, {
            AppReference: this.appReference,
            booking_source:'ZBAPINO00008',
            //userType: 'B2B'
        }).subscribe(resp => {
            if (resp.statusCode == 200) {
                this.loading=false;
                // this.updateSubAgent(resp);
                // this.deductFromWallet(this.appReference);
               this.hotelService.hotelConfirmationData.next(resp.data);
                this.router.navigate(['/hotel-voucher'], { queryParams: { AppReference: this.appReference, BookingSource: this.booking_source } });
            } else {
                setTimeout(() => {
                    this.hotelService.loading.next(false);
                    this.loading=true;
                }, 100);
            }
        }, err => {
            this.swalService.alert.oops(err.error.Message);
            this.loading=false;
            console.error(err);
        })
    }
    updateSubAgent(resp) {
        this.currentUser = this.util.getStorage('currentUser');
        let totalFare: any = 0;
        totalFare += resp.data["BookingItineraryDetails"][0].RoomPrice;
        let balance = String(this.currentUser.agent_balance - totalFare);
        this.subSink.sink = this.apiHandlerService.apiHandler('updateSubAgent', 'post', {}, {}, {
            id: this.currentUser.id,
            agent_balance: balance
        }).subscribe(res => {
            if (resp.statusCode == 201) {
                this.subSink.sink = this.apiHandlerService.apiHandler('getAgentById', 'post', {}, {}, {
                    id: this.currentUser.id
                }).subscribe(data => {
                    res['data']['access_token'] = this.currentUser.access_token;
                    sessionStorage.setItem('currentUser', JSON.stringify(res['data']));
                });
            }
        })
    }
    deductFromWallet(appReference) {
        this.subSink.sink = this.apiHandlerService.apiHandler('deductFromWallet', 'post', '', '', { app_reference: appReference }).subscribe(res => {
            if (res) {
                if (res.data[2].order_id && res.data[2].RemainingBalance > 0) {
                    this.swalService.alert.success("Your transaction is successful.")
                    //this.headerService.agentData.next(true);
                    this.hotelService.loading.next(true);
                    this.router.navigate(['/search/hotel/confirmation'], { queryParams: { AppReference: appReference, source: this.booking_source, orderId: res.data[2].order_id } });
                }
            }

        }, (err) => {
            this.hotelService.loading.next(false);
            this.swalService.alert.oops("Your wallet balence is not sufficient.");
        });
    }
    confimationBooking(appReference) {
        this.hotelService.loading.next(true);
        this.subSink.sink = this.apiHandlerService.apiHandler('reservation', 'post', {}, {}, {
            AppReference: appReference,
            booking_source: this.booking_source
        }).subscribe(resp => {
            if (resp.statusCode == 200) {
                this.currentUser = this.util.getStorage('b2cUser');
                let totalFare: any = 0;
                resp.data["BookingItineraryDetails"].forEach(itinerary => {
                    totalFare += itinerary.RoomPrice;
                });
                let balance = String(this.currentUser.agent_balance - totalFare);
                this.subSink.sink = this.apiHandlerService.apiHandler('updateSubAgent', 'post', {}, {}, {
                    id: this.currentUser.id,
                    agent_balance: balance
                }).subscribe(res => {
                    if (resp.statusCode == 201) {
                        this.subSink.sink = this.apiHandlerService.apiHandler('getAgentById', 'post', {}, {}, {
                            id: this.currentUser.id
                        }).subscribe(data => {
                            res['data']['access_token'] = this.currentUser.access_token;
                            sessionStorage.setItem('b2cUser', JSON.stringify(res['data']));
                        });
                    }
                })
                this.hotelService.hotelConfirmationData.next(resp.data);
                this.router.navigate(['/hotel-confirmation'], { queryParams: { AppReference: appReference, booking_source: this.booking_source } });
            } else {
                this.swalService.alert.oops(resp.Message);
                setTimeout(() => {
                    this.router.navigate(['/']);
                }, 100);
            }
        }, err => {
            console.error(err);
        })
        this.hotelService.loading.next(false);
    }


    // getCancelationPolicy(cancellationPolicy) {
    //     let policy = JSON.parse(cancellationPolicy.replace(/'/gi, "\""));
    //     if (policy['NonRefundable']) {
    //         return `Non Refundable`;
    //     } else if (!policy['NonRefundable']) {
    //         let penalty = '';
    //         if (typeof policy['CancelPenalty'] == 'object') {
    //             policy['CancelPenalty'].forEach((element, i) => {
    //                 penalty += `Cancellation made <strong>${element.HoursBefore} hours</strong> before checkin <strong>${element.Penalty.Currency + ' ' + element.Penalty.Value}</strong> will be charged as cancellation penalty`;
    //                 if (policy['CancelPenalty'].length - 1 != i) {
    //                     penalty += '<br>'
    //                 }
    //             });
    //             return penalty;
    //         } else {
    //             penalty += `You may cancel your booking for <strong>no charge</strong> on or before <strong>${policy['CancelPenalty']}</strong>`;
    //             return penalty;
    //         }
    //     }
    // }

        payNow() {
            this.router.navigate(['/hotel-confirmation'], { queryParams: { AppReference: this.appReference, OrderId: 12512, BookingSource: this.booking_source } });
            //this.getPaymentGateWays();
        }


    hide() {
        this.showPaymentDetails = false;
    }

    paymentConfirm() {
        this.submitted = true;
        if (!this.paymentForm.valid)
            return;
        if (this.paymentForm.value.paymentMethod && this.paymentForm.value.paymentMethod != '') {
            switch (this.paymentForm.value.paymentMethod) {
                case 'nagad':
                    this.nagadPayment();
                    break;
                case 'bKash':
                    this.srcUrl = `${b2b_url}/paymentGateway/${this.appReference}`;
                    window.location.replace(this.srcUrl);
                    break;
                case 'sslCommerz':
                    this.sslCommerzPayment();
                    break;

                default:
                    break;
            }
        }
    }

    bKashPayment(appReference) {
        let invoiceNumber=this.hotelService.setHotelInvoiceNumber(appReference);
        this.subSink.sink = this.apiHandlerService.apiHandler('completeBooking', 'post', {}, {}, {
            app_reference: appReference,
            payment_type: "bKash",
            merchantInvoiceNumber: invoiceNumber
        }).subscribe(resp => {
            if (resp.statusCode == 201 || resp.statusCode == 200) {
            }
        })
    }

    nagadPayment() {
        let invoiceNumber=this.hotelService.setHotelInvoiceNumber(this.appReference);
        this.hotelService.loading.next(true);
        let date = (new Date().getTime()).toString();
        this.subSink.sink = this.apiHandlerService.apiHandler('executePayment', 'post', {}, {}, {
            app_reference: this.appReference,
            order_id: `HBPI${date.substr(10)}${date.substr(0, 7)}${date.substr(7)}`,
            payment_type: "nagad",
            merchantInvoiceNumber: invoiceNumber
        }).subscribe(resp => {
            if (resp.statusCode == 201 || resp.statusCode == 200) {
                this.hotelService.loading.next(false);
                window.location = resp.data.callBackUrl
            }
        })
    }

    sslCommerzPayment() {
        let date = (new Date().getTime()).toString();
        this.subSink.sink = this.apiHandlerService.apiHandler('sslTransactionInit', 'post', {}, {}, {
            app_reference: this.appReference,
            order_id: `FBPI${date.substr(10)}${date.substr(0, 7)}${date.substr(7)}`,
            payment_type: 'sslCommerz'
        }).subscribe(resp => {
            if (resp.statusCode == 201 || resp.statusCode == 200) {
                window.location = resp.data.ssl
            }
        })
    }

    public openDialog(paymentType) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'dialog-container';
        if (paymentType == "nagad") {
            dialogConfig.width = '850px';
            dialogConfig.height = '250px';
        }
        if (paymentType == 'bKash') {
            dialogConfig.width = '100vw';
            dialogConfig.height = '100vw';
            dialogConfig.maxWidth = '100vw';
            dialogConfig.position = {
                top: '30px',
                left: '80px'
            }
        }
        dialogConfig.autoFocus = true;
        dialogConfig.disableClose = false;
        dialogConfig.data = {
            appReference: this.appReference,
            paymentType: paymentType,
            merchantInvoiceNumber: "Inv002"
        };
        this.dialog
            .open(HotelPaymentConfirmationComponent, dialogConfig)
            .afterClosed().subscribe(result => {
            })
    }

    getStarArray(num) {
        num = Number(num);
        let starArr = [];
        if (num && num >= 0)
            starArr.length = Math.round(num);
        return starArr;
    }

    getStarArrayRemaining(num) {
        num = Number(num);
        let starArr = [];
        if (num && num >= 0)
            starArr.length = 5 - Math.round(num);
        return starArr;
    }

    getHotelPhoto(imgArrStr) {
        if (imgArrStr != null) {
            let imgArray = JSON.parse(imgArrStr.replace(/'/gi, "\""));
            console.log("imgArray",imgArray)
            return imgArray;
        } else {
            return '';
        }
    }

    getPaymentGateWays() {
        this.apiHandlerService.apiHandler('getPaymentGateWays', 'POST', '', '', {}).subscribe(res => {
            if (res && ([200, 201].includes(res.statusCode))) {
                if (res.data && res.data.length > 0) {
                    res.data = res.data.filter(paymentGateway => paymentGateway.remarks != 'Wallet')
                    this.paymentGateways = res.data;
                    if (res.data && res.data.length > 0) {
                        this.showPaymentDetails = true;
                        this.cdr.detectChanges();
                    }
                    else {
                        this.swalService.alert.oops('No payment gateway enabled.');
                        this.showPaymentDetails = false;
                        this.cdr.detectChanges();
                    }
                }
                else {
                    this.swalService.alert.oops('Some thing went wrong');
                    this.showPaymentDetails = false;
                    this.cdr.detectChanges();
                }
            }
            else {
                this.swalService.alert.oops('Some thing went wrong');
                this.showPaymentDetails = false;
                this.cdr.detectChanges();
            }
        }, (err) => {
            if (err && err.err && err.error.msg) {
                this.swalService.alert.oops(err.error.msg);
                this.showPaymentDetails = false;
                this.cdr.detectChanges();
            }
        });
    }

    ngOnDestroy() {
        this.subSink.unsubscribe();
    }
}